import template from './city.html';
import controller from './city.controller';
import './city.scss';

let cityComponent = {
  bindings: {},
  template,
  controller
};

export default cityComponent;



// WEBPACK FOOTER //
// ./client/app/components/city/city.component.js